import { render, staticRenderFns } from "./adaptive-table.vue?vue&type=template&id=1d6bdb7b"
import script from "./adaptive-table.vue?vue&type=script&lang=js"
export * from "./adaptive-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports